import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type RemoveAllowedRoleMutationVariables = Types.Exact<{
  roleId: Types.Scalars['bigint']['input'];
  userId: Types.Scalars['bigint']['input'];
}>;


export type RemoveAllowedRoleMutation = { __typename?: 'mutation_root', delete_usertoroles?: { __typename?: 'usertoroles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'usertoroles', role_id: number, user_id: number }> } | null };


export const RemoveAllowedRoleDocument = gql`
    mutation removeAllowedRole($roleId: bigint!, $userId: bigint!) {
  delete_usertoroles(
    where: {_and: {role_id: {_eq: $roleId}, user_id: {_eq: $userId}}}
  ) {
    affected_rows
    returning {
      role_id
      user_id
    }
  }
}
    `;
export type RemoveAllowedRoleMutationFn = Apollo.MutationFunction<RemoveAllowedRoleMutation, RemoveAllowedRoleMutationVariables>;

/**
 * __useRemoveAllowedRoleMutation__
 *
 * To run a mutation, you first call `useRemoveAllowedRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllowedRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllowedRoleMutation, { data, loading, error }] = useRemoveAllowedRoleMutation({
 *   variables: {
 *      roleId: // value for 'roleId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveAllowedRoleMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAllowedRoleMutation, RemoveAllowedRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAllowedRoleMutation, RemoveAllowedRoleMutationVariables>(RemoveAllowedRoleDocument, options);
      }
export type RemoveAllowedRoleMutationHookResult = ReturnType<typeof useRemoveAllowedRoleMutation>;
export type RemoveAllowedRoleMutationResult = Apollo.MutationResult<RemoveAllowedRoleMutation>;
export type RemoveAllowedRoleMutationOptions = Apollo.BaseMutationOptions<RemoveAllowedRoleMutation, RemoveAllowedRoleMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/removeAllowedRole.mutation.gql}
 */
export async function removeAllowedRole(
  variables: RemoveAllowedRoleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RemoveAllowedRoleMutation['delete_usertoroles']>
export async function removeAllowedRole(
  variables: RemoveAllowedRoleMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RemoveAllowedRoleMutation>
export async function removeAllowedRole(
  variables: RemoveAllowedRoleMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RemoveAllowedRoleMutation['delete_usertoroles'] | RemoveAllowedRoleMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RemoveAllowedRoleMutation>(
    RemoveAllowedRoleDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_usertoroles
}